import React from "react";
import { Video } from "lucide-react";
import Reveal from "../Reveal";
import { buildWhatsAppLink, INSTAGRAM_URL } from "../../lib/api";
import { APPOINTMENT_TEXT } from "../../lib/home-content";
import { InstagramIcon } from "../BrandIcons";

const FinalCTASection = () => (
  <section
    id="contact"
    className="scroll-mt-24"
    style={{ background: "linear-gradient(135deg, #B7E4F4 0%, #4A3FCF 55%, #0F1245 100%)" }}
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32 text-center">
      <Reveal>
        <div className="overline" style={{ color: "#B7E4F4" }}>Get In Touch</div>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-white mt-4 leading-[1.05] max-w-3xl mx-auto">
          Stock from <span className="italic text-[#B7E4F4]">Style India Now.</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-[15px] text-white/80 leading-relaxed">
          One WhatsApp message is all it takes. We&apos;ll set up a video call, walk you through the latest designs and finalise prices, MOQ and delivery — all without you leaving your chair.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={buildWhatsAppLink(APPOINTMENT_TEXT)}
            target="_blank"
            rel="noreferrer"
            data-testid="final-cta-appointment"
            className="btn-primary !bg-white !text-[#0F1245] !border-white hover:!bg-[#0F1245] hover:!text-white hover:!border-[#0F1245]"
          >
            <Video size={14} strokeWidth={1.5} /> Book an Appointment
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="final-cta-catalogue"
            className="btn-secondary !border-white !text-white hover:!bg-white hover:!text-[#0F1245]"
          >
            <InstagramIcon size={14} /> Discover Our Range
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTASection;
